import React from 'react';
import { styled } from '@mui/material';
import type { SvgIconComponent } from '@mui/icons-material';
import { Colors } from 'library';
import { IconTitle } from './IconTitle';

interface FormCardProps {
    title?: string;
    icon?: SvgIconComponent;
    children: React.ReactNode;
    headerButton?: React.ReactNode;
}

export function FormCard({ title, icon, children, headerButton }: FormCardProps) {
    return (
        <Card>
            {title && (
                <TitleRow>
                    <IconTitle icon={icon}>{title}</IconTitle>
                    {headerButton && <HeaderButtonWrapper>{headerButton}</HeaderButtonWrapper>}
                </TitleRow>
            )}
            {children}
        </Card>
    );
}

const Card = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    border: `1px solid ${Colors.lightGrey}`,
    borderRadius: 10,
    padding: '28px 32px',
    backgroundColor: Colors.white,
});

const TitleRow = styled('div')({
    display: 'flex',
    alignItems: 'center',
});

const HeaderButtonWrapper = styled('div')({
    marginLeft: 'auto',
});
